import { fetchAsObservable } from 'fetcher!sofe'

export function resendEmail(channelId = null) {
  return fetchAsObservable(`/mfa-email${channelId ? `?uuid=${channelId.replace(/public-/g, '')}` : ''}}`, {
    method: 'post',
    passThrough401: true
  })
}

export function loginAfterMFA(channelId = null) {
  return fetchAsObservable(`/mfa-login${channelId ? `?uuid=${channelId.replace(/public-/g, '')}` : ''}`, {
    method: 'post',
    passThrough401: true
  })
}
